import { Variant } from '../../../Variant/Variant';
import styles from './ClassicQuiz.module.css';
import { motion } from 'motion/react';

export const ClassicQuiz = ({
  variants,
  isStateCorrectVar,
  delayTransition,
}) => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 1, delay: 0.7 + delayTransition }}
      className={styles.variantsContainer}
    >
      {variants?.map((item, i) => (
        <motion.div
          key={item.coment + String(i)}
          initial={{
            transform: 'scale(0)',
            opacity: 0,
            originX: 0,
            originY: 'center',
          }}
          animate={{
            transform: 'scale(1)',
            opacity: 1,
            originX: 0,
            originY: 'center',
          }}
          transition={{ duration: 1, delay: i * 0.8 + 1 + delayTransition }} // 1 анимация вопроса
        >
          <Variant
            item={item}
            index={i}
            aciveAmimate={isStateCorrectVar && item.correct}
          />
        </motion.div>
      ))}
    </motion.div>
  );
};
